import React from 'react';
import { PropTypes } from 'prop-types';

const BlankPage = ({ children }) => (
  <div className="page">
    <div className="page-body">
      { children }
    </div>
  </div>
);

BlankPage.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default BlankPage;
